import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const RefreshIcon = ({ color = 'black', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M4.38491 4.21052L6.65562 6.48129L6.06015 7.07668L2.77296 3.78947L5.97595 0.586548L6.5714 1.18194L4.38494 3.36841H7.99999C11.4881 3.36841 14.3158 6.19609 14.3158 9.68421C14.3158 13.1723 11.4881 16 7.99999 16C4.51188 16 1.6842 13.1723 1.6842 9.68421V9.26315H2.52631V9.68421C2.52631 12.7072 4.97696 15.1579 7.99999 15.1579C11.023 15.1579 13.4737 12.7072 13.4737 9.68421C13.4737 6.66117 11.023 4.21052 7.99999 4.21052H4.38491Z" fill={color} stroke={color} />
    </svg>
  );
};

export default RefreshIcon;
